import { AxiosError } from 'axios'

export const extractErrorMessage = (error: unknown): string => {
  if (!error) {
    return 'An unexpected error occurred'
  }

  if (error instanceof AxiosError) {
    const responseData = error.response?.data

    if (typeof responseData === 'string') {
      try {
        const parsed = JSON.parse(responseData)
        if (parsed?.detail) return String(parsed.detail)
        if (parsed?.message) return String(parsed.message)
        if (parsed?.error) return String(parsed.error)
      } catch {
        return responseData
      }
    }

    if (responseData && typeof responseData === 'object') {
      if ('detail' in responseData) {
        if (
          typeof responseData.detail === 'string' &&
          responseData.detail.trim()
        ) {
          return responseData.detail
        }

        if (
          responseData.detail !== null &&
          responseData.detail !== undefined &&
          typeof responseData.detail === 'object' &&
          'detail' in responseData.detail &&
          typeof responseData.detail.detail === 'string'
        ) {
          return responseData.detail.detail
        }

        if (
          responseData.detail !== null &&
          responseData.detail !== undefined &&
          typeof responseData.detail === 'object' &&
          'message' in responseData.detail &&
          typeof responseData.detail.message === 'string'
        ) {
          return responseData.detail.message
        }

        if (responseData.detail !== null && responseData.detail !== undefined) {
          return String(responseData.detail)
        }
      }

      if (
        'message' in responseData &&
        typeof responseData.message === 'string'
      ) {
        return responseData.message
      }

      if ('error' in responseData) {
        if (typeof responseData.error === 'string') {
          return responseData.error
        }
        if (
          responseData.error !== null &&
          responseData.error !== undefined &&
          typeof responseData.error === 'object'
        ) {
          if (
            'detail' in responseData.error &&
            typeof responseData.error.detail === 'string'
          ) {
            return responseData.error.detail
          }
          if (
            'message' in responseData.error &&
            typeof responseData.error.message === 'string'
          ) {
            return responseData.error.message
          }
        }
      }

      if ('title' in responseData && typeof responseData.title === 'string') {
        return responseData.title
      }
    }

    if (error.message) {
      return error.message
    }
  }

  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'string') {
    try {
      const parsed = JSON.parse(error)
      if (parsed?.detail) return String(parsed.detail)
      if (parsed?.message) return String(parsed.message)
      if (parsed?.error) return String(parsed.error)
    } catch {
      return error
    }
  }

  if (error && typeof error === 'object') {
    const objError = error as {
      response?: {
        data?: {
          detail?: string | { detail?: string; message?: string }
          message?: string
          error?: string | { detail?: string; message?: string }
          title?: string
        }
      }
      message?: string
    }

    if (objError.response?.data) {
      const data = objError.response.data
      if (typeof data.detail === 'string') return data.detail
      if (data.detail && typeof data.detail === 'object') {
        if (data.detail.detail) return String(data.detail.detail)
        if (data.detail.message) return String(data.detail.message)
      }
      if (data.message) return data.message
      if (typeof data.error === 'string') return data.error
      if (data.error && typeof data.error === 'object') {
        if (data.error.detail) return String(data.error.detail)
        if (data.error.message) return String(data.error.message)
      }
      if (data.title) return data.title
    }

    if (objError.message) {
      return objError.message
    }
  }

  return 'An error occurred'
}
